// _importComponents.ts
// @ts-ignore
const modules = import.meta.glob('/templates/**/*.ts');

const asynchronouslyImportScript = async (cssSelector: string, path: string) => {
  const elements = document.querySelectorAll<HTMLElement>(cssSelector);
  const fullPath = `/templates/${path}.ts`;
  if (elements.length) {
    try {
      if (modules[fullPath]) {
        const module = await modules[fullPath]();
        elements.forEach((element) => module.default.init(element));
      } else {
        console.error(`Module not found: ${fullPath}`);
      }
    } catch (error) {
      console.error(`Error loading module ${fullPath}:`, error);
    }
  }
};

export default async () => {
  /* Sections */

  /* Components */
};
